import { Button, Paper, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import InputField from "components/UI/InputField";
import toast from "react-hot-toast";

const LogoutPage = () => {
  const { handleSubmit, reset, control, setValue, getValues } = useForm({});

  const onSubmit = async (data: any) => {
    console.log(data);
    // const workId: string = await workAdd(data.name, "author 1");
    // console.log("added", workId);
    toast.success("Logout");
  };

  // const name: string = workId ?

  return (
    <>
      <div>Logout</div>
      {/* <DivEml>
        <form>
          <InputField
            name="name"
            control={control}
            label="Name"
            defaultValue={""}
          />
          <Button onClick={handleSubmit(onSubmit)}>Submit</Button>
          <Button onClick={() => reset()} variant={"outlined"}>
            Reset
          </Button>
        </form>
      </DivEml> */}
    </>
  );
};

const DivEml = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  column-gap: 2rem;
  row-gap: 2rem;
  margin-top: 2rem;
`;

export default LogoutPage;
